import { useState } from 'react'
import { SurveyFrame } from './SurveyFrame'
import { SurveyPopup } from './SurveyPopup'
import { useSurvey } from './utils/useSurvey'
import { useLocalStorage } from '../../hooks/useLocalStorage'
import { User } from '../../entity/User'
import { LAST_INTERACTED_SURVEY_TIME } from '../../types/survey'

export const SurveyUi = () => {
    const authUser = new User()
    const [_lastSurveyTime, setLastSurveyTime] = useLocalStorage<string | null>(
        `${authUser.login}${LAST_INTERACTED_SURVEY_TIME}`,
        null
    )
    const [showSurveyFrame, setShowSurveyFrame] = useState(false)
    const { survey, nullifySurvey } = useSurvey()

    const showSurvey = (flag: boolean) => {
        setShowSurveyFrame(flag)
        setLastSurveyTime(Date.now().toString())
    }

    const handleSurveyFrameClose = () => {
        setShowSurveyFrame(false)
        nullifySurvey()
        setLastSurveyTime(Date.now().toString())
    }

    return showSurveyFrame && survey ? (
        <SurveyFrame
            survey={survey}
            onSurveyFrameClose={handleSurveyFrameClose}
        />
    ) : survey ? (
        <SurveyPopup
            survey={survey}
            onSurveyAccept={showSurvey}
            onSurveyClose={handleSurveyFrameClose}
        />
    ) : (
        <></>
    )
}
